// /* eslint-disable global-require */
// import React from 'react';
// import ReactDOM from 'react-dom';
import ReviewModalAppV2 from 'bundles/ReviewModal';

window.SS = window.SS || {};
window.SS.ReviewModalAppV2 = ReviewModalAppV2;
